import React from 'react';

const VariousResource = (props) => {
  const { resource,handleDragStart } = props
  return (
    <div>
    <div className='d-flex'>
      <div className='row text-primary fw-bold' draggable onDragStart={e => handleDragStart(e, "Resource",resource)}>{resource.resourceNo}</div>
      </div>
      <div className='d-flex' style={{flexWrap:'wrap'}}>
        <div style={{fontWeight:400,fontSize:'13px',width:'100%',marginBottom:'2px',alignItems: 'center'}} className='d-flex'> {resource.description}</div>
      </div>
    </div>
  )
}

export default VariousResource